module.exports = __webpack_public_path__ + "static/impact_1-7925a972ea3d4988e16884c513644402.png";